import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';

import { FavoritesList, FavoritesSearchParams, Stream, StreamStatus } from '@kitch/data-access/models';
import { StreamsService, TokenService } from '@kitch/data-access/services';

@Component({
  selector: 'app-favorites-streams',
  templateUrl: './favorites-streams.component.html',
  styleUrls: ['./favorites-streams.component.scss', './../favorites-shared.scss'],
})
export class FavoritesStreamsComponent implements OnInit {
  favoritesStreams: Stream[];
  purchasedStreams: Stream[];
  isLoading: boolean;
  profileId: string;

  constructor(
    private streamsService: StreamsService,
    private route: ActivatedRoute,
    private tokenService: TokenService,
  ) {}

  ngOnInit(): void {
    this.profileId = this.tokenService.getProfileId();

    this.getFavoritesStreams().subscribe();
  }

  private getFavoritesStreams(): Observable<FavoritesList<Stream>> {
    this.isLoading = true;
    const favoritesStreamParams: FavoritesSearchParams = {
      status: StreamStatus.PAST,
      profileId: this.profileId,
    };

    return this.streamsService.getFavoritedStreams(favoritesStreamParams).pipe(
      tap((streams) => {
        this.favoritesStreams = streams.results;
        this.purchasedStreams = streams.purchasedResults;
      }),
      finalize(() => this.isLoading = false),
    );
  }
}
